import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { DeviceItem, ItemToCustomerWebDto } from '@vectronic/util';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-edit-device',
  templateUrl: './edit-device.component.html',
  styleUrls: ['./edit-device.component.scss'],
  imports: [
    CardComponent,
    ReactiveFormsModule,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatHint,
    MatDialogActions,
    MatButton,
    MatIcon,
  ],
})
export class EditDeviceComponent implements OnInit {
  editDeviceForm: FormGroup;
  device: ItemToCustomerWebDto<DeviceItem>;
  result: ItemToCustomerWebDto<DeviceItem>;

  dialogRef = inject(MatDialogRef<EditDeviceComponent>);
  private fb = inject(FormBuilder);
  data: ItemToCustomerWebDto<DeviceItem> = inject(MAT_DIALOG_DATA);

  constructor() {
    this.device = this.data;
  }

  ngOnInit() {
    this.initializeForm();
  }

  isReader() {
    return this.device.role === 'READER';
  }

  reset() {
    this.initializeForm();
  }

  initializeForm() {
    this.editDeviceForm = this.fb.group({
      idDevice: [{ value: this.device.id, disabled: true }],
      deviceName: this.device.name,
      deviceLabel: this.device.label,
      description: this.device.description,
    });
  }

  apply() {
    if (this.editDeviceForm.valid) {
      const device = { ...this.device };
      const name = this.editDeviceForm.get('deviceName')?.value;
      const label = this.editDeviceForm.get('deviceLabel')?.value;
      const description = this.editDeviceForm.get('description')?.value;
      if (name) device.name = name;
      device.label = label;
      device.description = description;
      this.dialogRef.close(device);
    }
  }
}
